export default "__VITE_ASSET__ff5fc9c3__"